import React from 'react'
import styles from './styles/profile-header.module.scss'
import { Player, WtnColorsEnum } from 'types/global'
import WatchlistToggle from 'components/watchlist/WatchlistToggle'

interface ProfileWatchlistToggleProps {
  profile: Player
  isDisabled?: boolean
}

const ProfileWatchlistToggle = ({ isDisabled, profile }: ProfileWatchlistToggleProps) => (
  <div className={styles.addToWatchlist}>
    <WatchlistToggle player={profile} color={WtnColorsEnum.WHITE} hasText isDisabled={isDisabled} />
  </div>
)

export default ProfileWatchlistToggle
